import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "../types";

export default function CityProcessingTimeSection({
  city,
  state,
  options,
  intro,
  regionalAgency,
}: {
  city: string;
  state: string;
  options: ProcessingOption[];
  intro?: string;
  regionalAgency?: { name: string; address: string; distance: string };
}) {
  const agencyName = regionalAgency?.name || "the closest Regional Passport Agency";
  const agencyDistance = regionalAgency?.distance || "appointments required — typically booked weeks out";

  const emergencyOpt = options.find((o) => o.emergency);
  const emergencyDescription =
    emergencyOpt?.emergencyDescription ||
    `The ${agencyName} is the nearest passport agency — ${agencyDistance}. You must secure an NPIC appointment in advance — no walk-ins permitted. Be prepared: the drive, parking, wait time, and possibly being told to return the next day to pick up your passport can turn a one-day trip into two.`;

  const disclaimerText =
    "*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing.";

  const defaultIntro = "";

  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName={city}
      headingExtra={state}
      introText={intro || defaultIntro}
      options={options}
      emergencyDescription={emergencyDescription}
      disclaimerText={disclaimerText}
    />
  );
}